import { render } from "./NewBookings.vue?vue&type=template&id=1310dfd4&scoped=true"
import script from "./NewBookings.vue?vue&type=script&lang=js"
export * from "./NewBookings.vue?vue&type=script&lang=js"

import "./NewBookings.vue?vue&type=style&index=0&id=1310dfd4&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1310dfd4"]])

export default __exports__